<template>
  <div class="ticket-form-input-container">
    <div v-if="idsAnswerTerminaleAlertForzato">
      <div class="alert alert-warning" role="alert" v-html="intl[$store.state.lang]['alert_link_attivazione']">
       
      </div>
    </div>
    <div
      v-for="(input, index) in inputs"
      :key="index"
      class="input-container col-12"
    >
      <textInput
        v-if="getInputType(input.name) === 'textInput'"
        :labelKey="input.name"
        :inputId="input.name"
        :pattern="getPattern(input.name)"
        :errorLabelKey="input.name + '-field-not-ok'"
        :maxlength="getInputMaxLength(input.name)"
        :required="input.required"
        :ref="input.name"
        :type="getInputTextType(input.name)"
      />

      <textArea
        v-if="getInputType(input.name) === 'textArea'"
        :labelKey="input.name"
        :inputId="input.name"
        :pattern="getPattern(input.name)"
        :required="input.required"
        :ref="input.name"
        :defaultValue="input.defaultValue"
        @textArea-changed="(value) => {onTextInputChange(input.name,value)}"

      >
        <template v-slot:subLabel>
          <div v-if="input.subLabelHtml" v-html="input.subLabelHtml"></div>
        </template>
      </textArea>

      <datePickerInput
        v-if="getInputType(input.name) === 'date'"
        :labelKey="input.name"
        :inputId="input.name"
        :required="input.required"
        :ref="input.name"
      ></datePickerInput>

      <selectInput
        v-if="getInputType(input.name) === 'select'"
        :defaultOptions="getSelectOption(input.name)"
        :labelKey="input.name"
        :inputId="input.name"
        :required="input.required"
        :errorMessageKey="input.name + '-error'"
        :ref="input.name"
      ></selectInput>

      <multiSelectInput
        v-if="getInputType(input.name) === 'multiselect'"
        :defaultOptions="getSelectOption(input.name)"
        :labelKey="input.name"
        :inputId="input.name"
        :required="input.required"
        :errorMessageKey="input.name + '-error'"
        :ref="input.name"
      ></multiSelectInput>

      <pecOrPeo
        v-if="getInputType(input.name) === 'pec_peo_switch'"
        :labelKey="input.name"
        :inputId="input.name"
        :required="input.required"
        :patternEmail="getPattern('email')"
        :patternPec="getPattern('pec')"
        :ref="input.name"
      ></pecOrPeo>
    </div>
    <div v-if="idsAnswerTerminaleAlertForzato">
      <div class="alert alert-warning" role="alert" v-html="intl[$store.state.lang]['alert_link_attivazione']">
       
      </div>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import {
  nameToInputType,
  nameToInputPattern,
  nameToSelectOptions,
  nameToInputTextMaxLength,
  nameToInputTextType,
  nameToFormatDateFunction
} from "./utils";
import TextInput from "../formInputs/textInput/TextInput.vue";
import TextArea from "../formInputs/textArea/TextArea.vue";
import DatePickerInput from "../formInputs/datePickerInput/DatePickerInput.vue";
import SelectInput from "../formInputs/selectInput/SelectInput.vue";
import MultiSelectInput from "../formInputs/multiSelectInput/MultiSelectInput.vue";
import PecOrPeo from "../formInputs/pecPeoEmail/PecOrPeo.vue";

export default {
  name: "ticketFormInputs",
  components: {
    textInput: TextInput,
    textArea: TextArea,
    datePickerInput: DatePickerInput,
    selectInput: SelectInput,
    multiSelectInput: MultiSelectInput,
    pecOrPeo: PecOrPeo,
  },

  props: {
    answerId: {
      type: Number,
      default: null,
    },
    pattern: {
      type: String,
      default: null,
    },
    answerDetail: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    
  },
  beforeUnmount() {},
  data: function () {
    return {
      intl: intl,
      // inputs: this.answerDetail && this.answerDetail.answerShowInput ? this.answerDetail.answerShowInput : []
    };
  },
  methods: {
    checkFormInputsMessages() {
      this.inputs.map((input) => {
        if (
          this.$refs[input.name] &&
          this.$refs[input.name]["0"] &&
          this.$refs[input.name]["0"].checkMessage
        ) {
          this.$refs[input.name]["0"].checkMessage();
        }
      });
    },

    /**
     * Metodo che ritorna il payload per la creazione del ticket.
     *
     * @returns {boolean} Tutti gli input obbligatori sono compilati correttamente.
     * @description Questo metodo viene usato per stabilire se ogni input della form sia correttamente compilato
     *              Ogni componente che rappresenta un elemento della form deve avere il suo metodo requiredInputIsOk.
     */
    inputOblligatoriOk() {
      let inputOk = true;
      this.inputs.map((input) => {
        if (input.name !== "telefon" && input.name !== "mobile") {
          if (
            input.required &&
            this.$refs[input.name] &&
            this.$refs[input.name]["0"] &&
            !this.$refs[input.name]["0"].requiredInputIsOk()
          ) {
            inputOk = false;
          }
        }
        
      });
      if (inputOk) {
          inputOk = this.numeriDiTelefonoOk();
      }

      return inputOk;
    },

    onTextInputChange(name,value){
      const params = new URLSearchParams(window.location.search);
      const isGeam = params.get('isGeam');
      if(this.$store.state["libraryWiperConfig"].startFromAnswerId && isGeam == 'true' && name == 'question'){
        if(value.length <= 12 && !value.startsWith("Reset QRCode")){
          this.$refs[name]["0"].inputField = "Reset QRCode"
        }
      }
    },

    numeriDiTelefonoOk() {
      if (this.$refs["mobile"] && this.$refs["telefon"]) {
        if (
          this.$refs["telefon"]["0"].requiredInputIsOk() ||
          this.$refs["mobile"]["0"].requiredInputIsOk()
        ) {
          return true;
        } else {
          return false;
        }
      }else if(this.$refs["mobile"]){
        return this.$refs["mobile"]["0"].requiredInputIsOk()
      }else if(this.$refs["telefon"]){
        return this.$refs["telefon"]["0"].requiredInputIsOk()
      }
      return true;
    },

    /**
     * Metodo che ritorna il payload per la creazione del ticket.
     *
     * @returns {object} Payload da inviare alla creazione del ticket.
     * @description QUESTO METODO SERVE PER PRENDERE I VALORI DELLE INPUT CHE COMPONGONO LA FORM.
     *              Ogni input del ticket deve salvare il suo valore in una variabile 'inputField'
     *              inputField puà essere un valore o un oggetto.
     *              Nel caso in cui sia un oggetto tutte le sue proprietà saranno copiate all'interno di params
     */
    getInputParams() {
      let params = {};
      this.inputs.map((input) => {
        if (this.$refs[input.name] && this.$refs[input.name]["0"]) {
          
          if(this.$refs[input.name]["0"].inputField instanceof Date){
            params[input.name] = nameToFormatDateFunction(input.name,this.$refs[input.name]["0"].inputField)
          }
          else if (typeof this.$refs[input.name]["0"].inputField === "object") {
            params = { ...params, ...this.$refs[input.name]["0"].inputField };
          } else {
            params[input.name] = this.$refs[input.name]["0"].inputField;
          }

        }
      });
      return params;
    },
    getInputType(name) {
      return nameToInputType(
        name,
        this.$store.state.libraryWiperConfig.questionarioId
      );
    },
    getPattern(name) {
      return nameToInputPattern(
        name,
        this.$store.state.libraryWiperConfig.questionarioId
      );
    },
    getInputMaxLength(name) {
      return nameToInputTextMaxLength(name);
    },
    getSelectOption(name) {
      return nameToSelectOptions(name);
    },

    getInputTextType(name) {
      return nameToInputTextType(name);
    },
    checkInputs(inputs){
      return inputs.map((input) => {
      const params = new URLSearchParams(window.location.search);
      const isGeam = params.get('isGeam');
          if(input && input.name && this.$store.state["libraryWiperConfig"].startFromAnswerId &&  isGeam == 'true' && input.name === 'question'){
            input.defaultValue = "Reset QRCode"
          }
          return input
      })
    }
  },
  watch: {},
  computed: {
    inputs() {
      return this.answerDetail && this.answerDetail.answerShowInput
        ? this.checkInputs(this.answerDetail.answerShowInput)
        : [];
    },
    idsAnswerTerminaleAlertForzato() {
      //LOGICA RIPRESA DA WIPER VERSIONE JOOMLA, oer capire quale id dovesse avere l alert vi era una gestione a FE basata su id.
      let ids = null;
      let idAnswerTerminale = this.answerDetail?.id || null;

      if (this.$store?.state?.libraryWiperConfig?.idsAnswerTerminaleAlert && idAnswerTerminale) {
        ids = JSON.parse(
          this.$store?.state?.libraryWiperConfig?.idsAnswerTerminaleAlert
        );
        return ids.includes(idAnswerTerminale);
      } else if (process.env.VUE_APP_IDS_ANSWER_TERMINALE_ALERT && idAnswerTerminale ) {
        ids = JSON.parse(process.env.VUE_APP_IDS_ANSWER_TERMINALE_ALERT);
       
        return ids.includes(idAnswerTerminale);
      }
      return false;
    },
  },
};
</script>
